import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, browserPopupRedirectResolver } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from 'firebase/app-check';

const firebaseConfig = {
  apiKey: 'AIzaSyCcGnlPt2oc3u_py0QKAL5e5T1gfH7zFlM',
  authDomain: 'youstory.studio.aimpulse.io',
  projectId: 'youstory-ai',
  storageBucket: 'youstory-ai.appspot.com',
  messagingSenderId: '896106335063',
  appId: '1:896106335063:web:59f3e25afa56b0d67ecc12',
  // Public GA4 ID. Analytics loads only after opt-in (see analytics.js).
  measurementId: 'G-QMVSWELQQY',
};

const app = initializeApp(firebaseConfig);
export { app };

// App Check attests that requests come from our genuine app (blocks scripts/curl).
// Uses reCAPTCHA Enterprise (matches the provider registered in the App Check
// console). The SITE key is public by design, so it's safe in the client bundle.
// Only initialize when a key is configured, so the app still runs before setup.
if (process.env.VUE_APP_RECAPTCHA_SITE_KEY) {
  if (process.env.NODE_ENV !== 'production') {
    // Prints a debug token to the console; register it under
    // Firebase Console → App Check → Manage debug tokens for local dev.
    // eslint-disable-next-line no-undef
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(
      process.env.VUE_APP_RECAPTCHA_SITE_KEY
    ),
    isTokenAutoRefreshEnabled: true,
  });
}

const database = getFirestore(app);
export { database };

const auth = getAuth(app);
export { auth, browserPopupRedirectResolver };

const storage = getStorage(app);
export { storage };

// Region must match the deployed callable (see functions/index.js).
const functions = getFunctions(app, 'europe-west1');
export { functions };
